import gql from 'graphql-tag';

export const getExternalSystemsByCompanyId = gql`
query getExternalSystemsByCompanyId {
  getExternalSystemsByCompanyId {
    externalSystems {
      id
      name
      externalSystemRef
      integrationType
    }
  }
}
`;

export const getExternalIntegrationLinksByLeadId = gql`
query getExternalIntegrationLinksByLeadId($input: GetLeadByIdInput) {
  getExternalIntegrationLinksByLeadId(getLeadByIdInput: $input) {
    externalIntegrationLinks {
      id
      externalSystemRef
      externalLeadRef
      integrationType
      name
      createdAt
      user {
        name
        lastName
      }
    }
  }
}
`;
